import type { DeviceName } from './device';

export type Spacing = 'gutter' | 'none' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
export type ResponseSpacing = Partial<Record<DeviceName, Spacing>>;

export const paddings: Record<Spacing, string> = {
  none: 'p-0',
  xxlarge: 'p-xxlarge',
  xlarge: 'p-xlarge',
  large: 'p-large',
  medium: 'p-medium',
  small: 'p-small',
  gutter: 'p-gutter',
};

export const topPaddings: Record<Spacing, string> = {
  none: 'pt-0',
  xxlarge: 'pt-xxlarge',
  xlarge: 'pt-xlarge',
  large: 'pt-large',
  medium: 'pt-medium',
  small: 'pt-small',
  gutter: 'pt-gutter',
};

export const bottomPaddings: Record<Spacing, string> = {
  none: 'pb-0',
  xxlarge: 'pb-xxlarge',
  xlarge: 'pb-xlarge',
  large: 'pb-large',
  medium: 'pb-medium',
  small: 'pb-small',
  gutter: 'pb-gutter',
};

export const negativeBottomMargins: Record<Spacing, string> = {
  none: 'mb-0',
  xxlarge: '-mb-xxlarge',
  xlarge: '-mb-xlarge',
  large: '-mb-large',
  medium: '-mb-medium',
  small: '-mb-small',
  gutter: '-mb-gutter',
};

export const leftPaddings: Record<Spacing, string> = {
  none: 'pl-0',
  xxlarge: 'pl-xxlarge',
  xlarge: 'pl-xlarge',
  large: 'pl-large',
  medium: 'pl-medium',
  small: 'pl-small',
  gutter: 'pl-gutter',
};

export const rightPaddings: Record<Spacing, string> = {
  none: 'pr-0',
  xxlarge: 'pr-xxlarge',
  xlarge: 'pr-xlarge',
  large: 'pr-large',
  medium: 'pr-medium',
  small: 'pr-small',
  gutter: 'pr-gutter',
};

export const rightMargins: Record<Spacing, string> = {
  none: 'mr-0',
  xxlarge: 'mr-xxlarge',
  xlarge: 'mr-xlarge',
  large: 'mr-large',
  medium: 'mr-medium',
  small: 'mr-small',
  gutter: 'mr-gutter',
};

export const negativeLeftMargins: Record<Spacing, string> = {
  none: 'ml-0',
  xxlarge: '-ml-xxlarge',
  xlarge: '-ml-xlarge',
  large: '-ml-large',
  medium: '-ml-medium',
  small: '-ml-small',
  gutter: '-ml-gutter',
};

export const responsiveTopPaddings: Record<string, string> = {
  lg_none: 'lg:pt-0',
  lg_xxlarge: 'lg:pt-xxlarge',
  lg_xlarge: 'lg:pt-xlarge',
  lg_large: 'lg:pt-large',
  lg_medium: 'lg:pt-medium',
  lg_small: 'lg:pt-small',
  lg_gutter: 'lg:pt-gutter',

  md_none: 'md:pt-0',
  md_xxlarge: 'md:pt-xxlarge',
  md_xlarge: 'md:pt-xlarge',
  md_large: 'md:pt-small0',
  md_medium: 'md:pt-medium',
  md_small: 'md:pt-small',
  md_gutter: 'md:pt-gutter',
};

export const responsiveBottomPaddings: Record<string, string> = {
  lg_none: 'lg:pb-0',
  lg_xxlarge: 'lg:pb-xxlarge',
  lg_xlarge: 'lg:pb-xlarge',
  lg_large: 'lg:pb-large',
  lg_medium: 'lg:pb-medium',
  lg_small: 'lg:pb-small',
  lg_gutter: 'lg:pb-gutter',

  md_none: 'md:pb-0',
  md_xxlarge: 'md:pb-xxlarge',
  md_xlarge: 'md:pb-xlarge',
  md_large: 'md:pb-small0',
  md_medium: 'md:pb-medium',
  md_small: 'md:pb-small',
  md_gutter: 'md:pb-gutter',
};

export const responsiveNegativeBottomMargins: Record<string, string> = {
  lg_none: 'lg:mb-0',
  lg_xxlarge: 'lg:-mb-xxlarge',
  lg_xlarge: 'lg:-mb-xlarge',
  lg_large: 'lg:-mb-large',
  lg_medium: 'lg:-mb-medium',
  lg_small: 'lg:-mb-small',
  lg_gutter: 'lg:-mb-gutter',

  md_none: 'md:mb-0',
  md_xxlarge: 'md:-mb-xxlarge',
  md_xlarge: 'md:-mb-xlarge',
  md_large: 'md:-mb-large',
  md_medium: 'md:-mb-medium',
  md_small: 'md:-mb-small',
  md_gutter: 'md:-mb-gutter',
};

export const responsiveLeftPaddings: Record<string, string> = {
  lg_none: 'lg:pl-0',
  lg_xxlarge: 'lg:pl-xxlarge',
  lg_xlarge: 'lg:pl-xlarge',
  lg_large: 'lg:pl-large',
  lg_medium: 'lg:pl-medium',
  lg_small: 'lg:pl-small',
  lg_gutter: 'lg:pl-gutter',

  md_none: 'md:pl-0',
  md_xxlarge: 'md:pl-xxlarge',
  md_xlarge: 'md:pl-xlarge',
  md_large: 'md:pl-large',
  md_medium: 'md:pl-medium',
  md_small: 'md:pl-small',
  md_gutter: 'md:pl-gutter',
};

export const responsiveRightPaddings: Record<string, string> = {
  lg_none: 'lg:pr-0',
  lg_xxlarge: 'lg:pr-xxlarge',
  lg_xlarge: 'lg:pr-xlarge',
  lg_large: 'lg:pr-large',
  lg_medium: 'lg:pr-medium',
  lg_small: 'lg:pr-small',
  lg_gutter: 'lg:pr-gutter',

  md_none: 'md:pr-0',
  md_xxlarge: 'md:pr-xxlarge',
  md_xlarge: 'md:pr-xlarge',
  md_large: 'md:pr-large',
  md_medium: 'md:pr-medium',
  md_small: 'md:pr-small',
  md_gutter: 'md:pr-gutter',
};

export const responsiveNegativeLeftMargins: Record<string, string> = {
  lg_none: 'lg:ml-0',
  lg_xxlarge: 'lg:-ml-xxlarge',
  lg_xlarge: 'lg:-ml-xlarge',
  lg_large: 'lg:-ml-large',
  lg_medium: 'lg:-ml-medium',
  lg_small: 'lg:-ml-small',
  lg_gutter: 'lg:-ml-gutter',

  md_none: 'md:ml-0',
  md_xxlarge: 'md:-ml-xxlarge',
  md_xlarge: 'md:-ml-xlarge',
  md_large: 'md:-ml-large',
  md_medium: 'md:-ml-medium',
  md_small: 'md:-ml-small',
  md_gutter: 'md:-ml-gutter',
};

export const gaps = {
  default: {
    none: 'gap-0',
    gutter: 'gap-gutter',
    small: 'gap-small',
    medium: 'gap-medium',
    large: 'gap-large',
    xlarge: 'gap-xlarge',
    xxlarge: 'gap-xxlarge',
  },

  md: {
    none: 'md:gap-0',
    gutter: 'md:gap-gutter',
    small: 'md:gap-small',
    medium: 'md:gap-medium',
    large: 'md:gap-large',
    xlarge: 'md:gap-xlarge',
    xxlarge: 'md:gap-xxlarge',
  },

  lg: {
    none: 'lg:gap-0',
    gutter: 'lg:gap-gutter',
    small: 'lg:gap-small',
    medium: 'lg:gap-medium',
    large: 'lg:gap-large',
    xlarge: 'lg:gap-xlarge',
    xxlarge: 'lg:gap-xxlarge',
  },
};
